import { camelizeKeys, snakelizeKeys } from '@/lib/utils'
import { Banner } from '@/types/banner'
import { useQuery } from '@tanstack/react-query'

import { axiosInstance } from '../axios'

export const fetchBanners = async ({
  params,
}: {
  params: Record<string, string>
}): Promise<Banner[] | undefined> => {
  try {
    // @ts-ignore
    const response = await axiosInstance.get(`/banners`, {
      params: snakelizeKeys(params),
    })
    // @ts-ignore
    return camelizeKeys(response.list)
  } catch (error) {
    console.error('🚀 ~ fetchBanners ~ error:', error)
  }
}

export function useBanners({ params }: { params?: Record<string, string> }) {
  return useQuery({
    queryKey: ['banners', params],
    queryFn: () =>
      fetchBanners({
        params: params || {},
      }),
    retry: false,
  })
}
